@if (isLoaded()) {
  <div class="list-container">
    <mat-selection-list [hideSingleSelectionIndicator]="true" [multiple]="false" (selectionChange)="onSelection($event)">
      @for (item of data; track item) {
        <mat-list-option [value]="item.id">
          <ldw-web-doku-list-item [webDoku]="item" class="no-padding"></ldw-web-doku-list-item>
        </mat-list-option>
      }
    </mat-selection-list>
    @if (!hasData()) {
      <p>{{ 'WEBDOKU.NOWEBDOKUS' | translate }}</p>
    }
  </div>
}
@if (!isLoaded()) {
  <div>
    <div>{{ 'WEBDOKU.LOADING' | translate }}</div>
  </div>
}
